// import React, { useState, useEffect } from "react";

// // reactstrap components
// import {Card,CardHeader,CardBody,Container,Row,
//   Col,
//   FormGroup,
//   Input,
// } from "reactstrap";
// // core components
// import Header from "components/Headers/Header";
// import AddSubCategory from "components/SubCategory/AddSubCategory";
// import AllSubCategory from "components/SubCategory/AllSubCategory";
// import Dataservices from "../../services/requestApi";
// import queryString from "query-string";
// import Loader from "components/loader/Loader";
// const SubCategory = () => {
//   const [subCategory, setSubCategory] = useState("");
//   const [allSubCategory, setAllSubCategory] = useState([]);
//   const [filterids, setFilterIds] = useState([]);
//   const [allfilter, setAllFilter] = useState([]);
//   const [update, setUpdate] = useState(false);
//   const [cateid, setCateId] = useState("");
//   const [search, setSearch] = useState("");
//   const [ready, setReady] = useState(false);
//   const [thumbnail, setThumbnail] = useState(null);
//   const [image, setImage] = useState(null);
//   const [category, setCategory] = useState("");
//   const [allCategory, setAllCategory] = useState([]);


//   // GetAllSubCategory
//   const getAllSubCategory = async (e) => {
//     try {
//       const [resSubCategory, resFilter] = await Promise.all([
//         Dataservices.SubCategoryAll(),
//         Dataservices.FilterAll(),
//       ]);
//       setAllSubCategory(resSubCategory.data.data);
//       setAllFilter(resFilter.data.data);
//     } catch (e) {
//       console.log(e);
//     }
//   };

//   // Fetch AllSubCategory
//   useEffect(() => {
//     getAllSubCategory();
//   }, []);

//   const getAllCategory = async (e) => {
//       try {
//         const [resCategory, resFilter] = await Promise.all([
//           Dataservices.CategoryAll(),
//           Dataservices.FilterAll(),
//         ]);
//         setAllCategory(resCategory.data.data);
//         setAllFilter(resFilter.data.data);
//       } catch (e) {
//         console.log(e);
//       }
//     };
  
//     // Fetch AllCategory
//     useEffect(() => {
//       getAllCategory();
//     }, []);

//   // AddCategory
//   const AddCategorys = async (e) => {
//     e.preventDefault();

//     setReady(true);
//     const form = new FormData();
//     form.append('sub_category', subCategory);
//     if(filterids.length > 0) {
//       form.append('filter', filterids);
//     }
//     form.append('image', image);
//     form.append('category', category);
//     const slugtext = subCategory.toLocaleLowerCase().replaceAll(" ", "-");
//     form.append('slug', slugtext);
//     try {
//       const res = await Dataservices.SubCategoryAdd(form);
//       console.log(res.data);
//       getAllSubCategory();
//       setSubCategory("");
//       setFilterIds([]);
//       setReady(false);
//     } catch (e) {
//       console.log(e);
//     }
//   };
//   // category Status
//   const categoryUpdateStatus = async (data) => {
//     setUpdate(true);
//     setSubCategory(data.subCategory);
//     setCategory(data.category);
//     setCateId(data._id);
//     setFilterIds(data.filter);
//     if (data.filter) {
//       const value = [];
//       for (let title of data.filter) {
//         value.push(title._id);
//       }
//       setFilterIds(value);
//     }
//   };
//   // Status
//   const status = async (e, val) => {
//     e.preventDefault();
//     try {
//       const Data = {
//         status: !val.status,
//       };
//       await Dataservices.SubCategoryUpdate(val._id, queryString.stringify(Data));
//       window.location.reload(false);
//     } catch (error) {
//       console.log(error);
//     }
//   };
//   // Category Updates
//   const categoryUpdate = async (e) => {
//     e.preventDefault();
//     try {
//       setReady(true);
//       const form = new FormData();
//       form.append('sub_category', subCategory);
//       if(filterids.length > 0) {
//         form.append('filter', filterids);
//       }
//       form.append('image', image);
//       form.append('category', category);
//       const slugtext = subCategory.toLocaleLowerCase().replaceAll(" ", "-");
//       form.append('slug', slugtext);
//       const res = await Dataservices.SubCategoryUpdate(
//         cateid,
//         form
//       );
//       setUpdate(false);
//       getAllSubCategory();
//       setSubCategory("");
//       setFilterIds(undefined);
//       setReady(false);
//     } catch (error) {
//       console.log(error);
//     }
//   };
//   // Delete Category
//   const deleteCategory = async (e, id) => {
//     console.log('delete category',e);
//     console.log('delete category',id);

//     e.preventDefault();
//     try {
//       const res = await Dataservices.SubCategoryDelete(id);
//       console.log(res);
//       getAllSubCategory();
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   const fileHandler = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setImage(file);
//       const files = URL.createObjectURL(file);
//       setThumbnail(files);
//     } else {
//       setImage(null);
//       setThumbnail(null);
//     }
//   };

//   const searchFilter = allSubCategory.filter((data) => {
//     return data.sub_category.toLowerCase().includes(search.toLowerCase());
//   });
//   return (
//     <>
//       <Header show={false} />
//       {/* Page content */}
//       <Container className="mt--7" fluid>
//         <Row>
//           <Col xl="4">
//             <Card className="card-profile shadow">
//               <CardHeader className="border-0">
//                 <Row className="align-items-center">
//                   <Col xs="9">
//                     <h3 className="mb-0">Add SubCategory</h3>
//                   </Col>
//                 </Row>
//               </CardHeader>
//               <CardBody className="pt-0 pt-md-4">
//                 <Row>
//                   <Col lg="12">
//                     <AddSubCategory
//                       SubCategory={subCategory}
//                       allfilter={allfilter}
//                       filterids={filterids}
//                       setFilter={setFilterIds}
//                       setSubCategory={setSubCategory}
//                       addcategory={AddCategorys}
//                       updatecategory={categoryUpdate}
//                       statusupdate={update}
//                       handleImage={fileHandler}
//                       thumbnail={thumbnail}
//                       allCategory={allCategory}
//                       category={category}
//                       setCategory={setCategory}
//                     />
//                   </Col>
//                 </Row>
//               </CardBody>
//             </Card>
//           </Col>
//           <Col className="order-xl-1" xl="8">
//             <Card className="shadow">
//               <CardHeader className="bg-white border-0">
//                 <Row className="align-items-center">
//                   <Col xs="9">
//                     <h3 className="mb-0">All Sub Category</h3>
//                   </Col>
//                   <Col lg="3">
//                     <FormGroup className="mb-0">
//                       <Input
//                         className="shadow"
//                         id="title"
//                         placeholder="Search Sub Category"
//                         type="text"
//                         value={search}
//                         onChange={(e) => setSearch(e.target.value)}
//                       />
//                     </FormGroup>
//                   </Col>
//                 </Row>
//               </CardHeader>
//               <CardBody>
//                 <Loader show={ready} />
//                 <AllSubCategory
//                   allcategory={searchFilter}
//                   updatecategory={categoryUpdateStatus}
//                   deletecat={deleteCategory}
//                   status={status}
//                 />
//               </CardBody>
//             </Card>
//           </Col>
//         </Row>
//       </Container>
//     </>
//   );
// };

// export default SubCategory;





import React, { useState, useEffect } from "react";
import { Card, CardHeader, CardBody, Container, Row, Col, FormGroup, Input } from "reactstrap";
import Header from "components/Headers/Header";
import AddSubCategory from "components/SubCategory/AddSubCategory";
import AllSubCategory from "components/SubCategory/AllSubCategory";
import Dataservices from "../../services/requestApi";
import Loader from "components/loader/Loader";

const SubCategory = () => {
  const [subCategory, setSubCategory] = useState("");
  const [allSubCategory, setAllSubCategory] = useState([]);
  const [filterids, setFilterIds] = useState([]);
  const [allfilter, setAllFilter] = useState([]);
  const [update, setUpdate] = useState(false);
  const [cateid, setCateId] = useState("");
  const [search, setSearch] = useState("");
  const [ready, setReady] = useState(false);
  const [thumbnail, setThumbnail] = useState(null);
  const [image, setImage] = useState(null);
  const [category, setCategory] = useState("");
  const [allCategory, setAllCategory] = useState([]);

  // Fetch SubCategories & Filters
  const getAllSubCategory = async () => {
    try {
      const [resSubCategory, resFilter] = await Promise.all([
        Dataservices.SubCategoryAll(),
        Dataservices.FilterAll(),
      ]);
      setAllSubCategory(resSubCategory.data.data);
      setAllFilter(resFilter.data.data);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    getAllSubCategory();
    getAllCategory();
  }, []);

  // Fetch All Categories
  const getAllCategory = async () => {
    try {
      const resCategory = await Dataservices.CategoryAll();
      setAllCategory(resCategory.data.data);
    } catch (e) {
      console.log(e);
    }
  };

  // Add SubCategory
  const AddCategorys = async (e) => {
    e.preventDefault();
    setReady(true);

    const form = new FormData();
    form.append('sub_category', subCategory);
    if (filterids.length > 0) form.append('filter', filterids);
    if (image) form.append('image', image);
    form.append('category', category);
    form.append('slug', subCategory.toLowerCase().replaceAll(" ", "-"));

    try {
      await Dataservices.SubCategoryAdd(form);
      getAllSubCategory();
      resetForm();
    } catch (e) {
      console.log(e);
    } finally {
      setReady(false);
    }
  };

  // Prefill update form
  const categoryUpdateStatus = (data) => {
    setUpdate(true);
    setSubCategory(data.sub_category);
    setCategory(data.category?._id || "");
    setCateId(data._id);

    if (data.filter) {
      const filterValues = data.filter.map(f => f._id);
      setFilterIds(filterValues);
    } else {
      setFilterIds([]);
    }

    if (data.image) setThumbnail(data.image);
    else setThumbnail(null);
  };

  // Update SubCategory
  const categoryUpdate = async (e) => {
    e.preventDefault();
    setReady(true);

    try {
      const form = new FormData();
      form.append('sub_category', subCategory);
      if (filterids.length > 0) form.append('filter', filterids);
      if (image) form.append('image', image);
      form.append('category', category);
      form.append('slug', subCategory.toLowerCase().replaceAll(" ", "-"));

      await Dataservices.SubCategoryUpdate(cateid, form);
      getAllSubCategory();
      resetForm();
    } catch (error) {
      console.log(error);
    } finally {
      setReady(false);
    }
  };

  const deleteCategory = async (e, id) => {
    e.preventDefault();
    try {
      await Dataservices.SubCategoryDelete(id);
      getAllSubCategory();
    } catch (error) {
      console.log(error);
    }
  };

  const fileHandler = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setThumbnail(URL.createObjectURL(file));
    } else {
      setImage(null);
      setThumbnail(null);
    }
  };

  const resetForm = () => {
    setSubCategory("");
    setFilterIds([]);
    setCategory("");
    setImage(null);
    setThumbnail(null);
    setUpdate(false);
  };

  const searchFilter = allSubCategory.filter((data) =>
    data.sub_category.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <>
      <Header show={false} />
      <Container className="mt--7" fluid>
        <Row>
          <Col xl="4">
            <Card className="card-profile shadow">
              <CardHeader className="border-0">
                <h3 className="mb-0">Add / Update SubCategory</h3>
              </CardHeader>
              <CardBody>
                <AddSubCategory
                  SubCategory={subCategory}
                  allfilter={allfilter}
                  filterids={filterids}
                  setFilter={setFilterIds}
                  setSubCategory={setSubCategory}
                  addcategory={AddCategorys}
                  updatecategory={categoryUpdate}
                  statusupdate={update}
                  handleImage={fileHandler}
                  thumbnail={thumbnail}
                  allCategory={allCategory}
                  category={category}
                  setCategory={setCategory}
                />
              </CardBody>
            </Card>
          </Col>

          <Col xl="8">
            <Card className="shadow">
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <Col xs="9">
                    <h3 className="mb-0">All Sub Category</h3>
                  </Col>
                  <Col xs="3">
                    <FormGroup>
                      <Input
                        className="shadow"
                        placeholder="Search Sub Category"
                        type="text"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Loader show={ready} />
                <AllSubCategory
                  allcategory={searchFilter}
                  updatecategory={categoryUpdateStatus}
                  deletecat={deleteCategory}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default SubCategory;
